module.exports = __webpack_public_path__ + "img/motor_no33.059172ad.jpg";